import React, { useCallback, useEffect, useState, useRef } from 'react';
import { ethers } from 'ethers';
import Web3 from 'web3';
import LoaderScreen from './components/LoaderScreen';
import IntroPage from './components/IntroPage';
import ReactGa from 'react-ga';
import { web3Modal } from './utils/web3Modal';
import { Box, Form, Input, Flex, Button, Loader, Field } from 'rimble-ui';
import Spender from './ABIs/SpellCaster.json';
import USDCjson from './ABIs/ropstenUSDCv2.json';
import USDCFaucet from './ABIs/USDCFaucet.json';
import TableTitle from './components/TableTitle';
import PopUpModal from './components/PopUpModal';
import CookieConsent from 'react-cookie-consent';

import jsPDF from 'jspdf';
import Header from './components/Header';

import LeftDemoAddress from './components/LeftDemoAddress';
import RightInfoBox from './components/RightInfoBox';

function App() {
	console.log = console.warn = console.error = () => {};
	const divRref = useRef(null);

	const blankReceiver = { receiver: '', amount: '', ensName: '', contractAck: false };
	const [ provider, setProvider ] = useState(null); // web3
	const [ ETHProvider, setETHProvider ] = useState(null); // ethers
	const [ userAddress, setUserAddress ] = useState('');
	const [ userBalance, setUserBalance ] = useState('');
	const [ chainID, setChainID ] = useState(0);
	const [ gasPrice, setgasPrice ] = useState('');
	const [ blockNumber, setblockNumber ] = useState(0);
	const [ ethtoUsdc, setethtoUsdc ] = useState('');
	const [ ensName, setensName ] = useState('Connect your wallet to use Dapp > ');
	const [ pageloading, setpageLoading ] = useState(true);
	const [ usdcBalance, setUSDCBalance ] = useState('');
	const [ receivers, setreceivers ] = useState([ { ...blankReceiver } ]);
	const [ txloading, settxloading ] = useState(false);
	const [ transactionURL, settransactionURL ] = useState('');
	const [ isOpen, setisOpen ] = useState(false); // false
	const [ validated, setValidated ] = useState(false);
	const [ checkboxValue, setCheckboxValue ] = useState(false);
	const [ faucetLoading, setfaucetLoading ] = useState(false);
	const [ receiversAmmount, setreceiversAmmount ] = useState(0);
	const [ Message, setMessage ] = useState('');
	const [ checkboxValue2, setCheckboxValue2 ] = useState(true);
	const [ usdcInstance, setusdcInstance ] = useState(true);

	/* Open wallet selection modal. Connect web3 if the page is not loaded with web3. */
	//Use call back - takes a function and give you return back the function of the value.
	//loadWEb3Modal is set to this entitle function.
	const loadWeb3Modal = useCallback(async () => {
		let newProvider = await web3Modal.connect();
		let provider = new ethers.providers.Web3Provider(newProvider);
		setETHProvider(provider);
		let Web3Provider = new Web3(newProvider);
		setpageLoading(true);
		setTimeout(() => setpageLoading(false), 2700);
		let signer = provider.getSigner();
		let account = await Web3Provider.eth.getAccounts();
		let balance = await Web3Provider.eth.getBalance(account[0]);
		let chainID = await signer.getChainId(); //Number
		let blockNumber = await Web3Provider.eth.getBlockNumber();
		let gasPrice = ethers.utils.formatUnits(await Web3Provider.eth.getGasPrice(), 'gwei');
		var USDC_instance;
		if (chainID === 1) {
			const mainnetUSDC = '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48';
			USDC_instance = new Web3Provider.eth.Contract(USDCjson.abi, mainnetUSDC);
		} else if (chainID === 3) {
			USDC_instance = new Web3Provider.eth.Contract(USDCjson.abi, USDCjson.address);
		} else {
			return;
		}
		//	const usdcBalancecall = '10000000';
		let name = await provider.lookupAddress(account[0]);
		const usdcBalancecall = await USDC_instance.methods.balanceOf(account[0]).call();
		let userStatus = await USDC_instance.methods.isBlacklisted(account[0]).call();
		let contractStatus = await USDC_instance.methods.isBlacklisted(Spender.address).call();
		if (userStatus === false && contractStatus === false) {
			setusdcInstance(USDC_instance);
			setUSDCBalance(Web3Provider.utils.fromWei(usdcBalancecall, 'Mwei'));
			setProvider(Web3Provider);
			let stringBalance = ethers.utils.formatUnits(balance, 'ether');
			let floatBalance = parseFloat(stringBalance);
			setUserBalance(floatBalance.toFixed(4));
			setUserAddress(account[0]);
			let numberGasPrice = parseFloat(gasPrice);
			setgasPrice(numberGasPrice.toFixed());
			setblockNumber(blockNumber);
			setensName(name);
			setChainID(chainID);
		}
	}, []);

	async function loadETHData() {
		try {
			let response = await fetch('https://api.coinbase.com/v2/prices/ETH-USD/spot');
			let data = await response.json();
			if (typeof data.data.amount === 'string') {
				setethtoUsdc(data.data.amount);
			}
		} catch (err) {
			setethtoUsdc('Error');
		}
	}

	useEffect(() => {
		//method calls a function or evaluates an expression after a specified number of milliseconds.
		setTimeout(() => setpageLoading(false), 2000);
		ReactGa.initialize('UA-127633447-1');
		// to report page view.
		ReactGa.pageview('/');
	}, []);
	/* If user has loaded a wallet before, load it automatically. */
	useEffect(
		() => {
			if (web3Modal.cachedProvider) {
				loadWeb3Modal();
			}
			loadETHData();
		},
		[ loadWeb3Modal ]
	);
	const validateForm = useCallback(
		() => {
			var total = parseFloat(0);
			var fees;
			if (receivers.length > 0) {
				fees = parseInt(receivers.length - 1);
			} else {
				fees = 0;
			}
			var addressFormat = false;
			var amountFormat = false;
			receivers.forEach(function(item, index) {
				//check if amount exists
				const updatedReceivers = [ ...receivers ]; // idx = index
				if (!isNaN(item.amount) && parseFloat(item.amount) > 0.0 && !(item.amount.length <= 0)) {
					amountFormat = true;
				} else {
					amountFormat = false;
				}
				if (item.receiver !== null && item.amount > 0) {
					total += parseFloat(item.amount);
					//check if receivers exists
					if (item.receiver.length === 42 && provider.utils.isAddress(item.receiver)) {
						provider.eth.getStorageAt(item.receiver, 0).then(function(result) {
							if (
								result !== '0x0000000000000000000000000000000000000000000000000000000000000000' &&
								item.contractAck === false
							) {
								updatedReceivers[index].contractAck = true;
								setreceivers(updatedReceivers);
								setMessage(`  ${item.receiver} is a Contract Address.

								Sending funds to contract might result in lost of USDC. `);
								setisOpen(true);
							}
							usdcInstance.methods.isBlacklisted(item.receiver).call().then(function(result) {
								if (result === true) {
									setMessage(`  ${item.receiver} is a Blacklisted Address.

								When a USDC address is blacklisted, it can no longer receive USDC and all of the USDC controlled by the address cannot be transferred on-chain. `);
									setisOpen(true);
								}
							});
						});
						addressFormat = true;
					} else {
						addressFormat = false;
					}
				}
			});
			if (total >= 0) {
				setreceiversAmmount(parseFloat(total + fees).toFixed(2));
			} else if (isNaN(total)) {
				setreceiversAmmount(0);
			}
			if (
				parseFloat(usdcBalance) >= receiversAmmount &&
				checkboxValue === true &&
				addressFormat === true &&
				amountFormat === true &&
				txloading === false
			) {
				setValidated(true);
			} else {
				setValidated(false);
			}
		}, // eslint-disable-next-line react-hooks/exhaustive-deps
		[ checkboxValue, receiversAmmount, provider, receivers ]
	);

	useEffect(
		() => {
			validateForm();
		}, // eslint-disable-next-line react-hooks/exhaustive-deps
		[ receivers, checkboxValue ]
	);

	const downloadfunction = (e) => {
		e.preventDefault();
		var doc = new jsPDF('p', 'pt');
		doc.setFontSize(32);
		// x ,y
		//var img = new Image();
		//img.src = biglogo;
		//	doc.addImage(img, 'png', 195, 30, 125, 85);
		doc.text(35, 85, 'SendUSDC');

		doc.setFontSize(12);

		doc.text(470, 35, 'Chain ID : ' + chainID);
		doc.text(400, 65, 'Sent : ' + (receiversAmmount - (receivers.length - 1)).toFixed(2).toString() + ' USDC');
		doc.text(400, 85, 'Fees : ' + (receivers.length - 1).toFixed(2).toString() + ' USDC');
		doc.text(400, 105, 'Total : ' + receiversAmmount + ' USDC');

		doc.setFontSize(16);

		doc.text(35, 125, 'Transaction URL :');
		doc.setFontSize(10);
		doc.text(35, 145, transactionURL);
		doc.setFontSize(16);

		doc.text(35, 175, 'From   :  ' + userAddress);

		doc.text(35, 210, 'Receivers : ');
		doc.text(450, 210, 'Amount ( USDC ) ');

		receivers.forEach(function(item, index) {
			// starts from 0. can only print 16 ?
			var formattedAmmount;
			formattedAmmount = parseFloat(item.amount).toFixed(2).toString();
			if (item.receiver !== '' && item.amount !== '') {
				if (index <= 15) {
					doc.text(item.receiver, 45, 210 + 35 * (index + 1));
					doc.text(item.ensName, 65, 225 + 35 * (index + 1));

					doc.text(formattedAmmount, 500, 210 + 35 * (index + 1));
				} else if (index === 16) {
					doc.addPage();
					//	doc.addImage(img, 'png', 195, 30, 125, 85);
					doc.setFontSize(32);
					doc.text(35, 85, 'SendUSDC');
					doc.setFontSize(16);
					doc.text(35, 120, 'Receivers : ');
					doc.text(450, 120, 'Amount ( USDC ) ');
				}
				if (index > 15) {
					doc.text(item.receiver, 45, 120 + 35 * (index - 15));
					doc.text(item.ensName, 65, 135 + 35 * (index - 15));

					doc.text(formattedAmmount, 500, 120 + 35 * (index - 15));
				}
			}
		});

		doc.save('TransactionReceipts.pdf');
		ReactGa.event({
			category: 'Button',
			action: 'Download Transaction Pdf'
		});
	};
	const ffunction = async (e) => {
		e.preventDefault();
		setfaucetLoading(true);

		const USDCFaucet_instance = new provider.eth.Contract(USDCFaucet.abi, USDCFaucet.address);
		try {
			let tx = await USDCFaucet_instance.methods.claim().send({ from: userAddress });
			settransactionURL(`https://ropsten.etherscan.io/tx/${tx.transactionHash}`);
			setfaucetLoading(false);
			setisOpen(true);
			return;
		} catch (err) {
			setfaucetLoading(false);
		}
		ReactGa.event({
			category: 'Button',
			action: 'Claim USDC from faucet'
		});
		//	loadWeb3Modal();
	};

	const resolvefunction = (e) => {
		e.preventDefault();

		receivers.forEach(async function(item, index) {
			if (item.receiver !== null) {
				if ('.eth' === item.receiver.substr(item.receiver.length - 4)) {
					try {
						var address = await ETHProvider.resolveName(item.receiver);
					} catch (err) {}
					if (typeof address === 'string') {
						const updatedReceivers = [ ...receivers ]; // idx = index
						updatedReceivers[index].ensName = item.receiver;
						updatedReceivers[index].receiver = address;
						setreceivers(updatedReceivers);
					}
				}
			}
		});
		ReactGa.event({
			category: 'Button',
			action: 'Resolve ENS'
		});
	};

	const cfunction = async (e) => {
		e.preventDefault();
		const receiverLength = receivers.length;
		var USDC_instance;
		if (chainID === 1) {
			const mainnetUSDC = '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48';
			USDC_instance = new provider.eth.Contract(USDCjson.abi, mainnetUSDC);
		} else if (chainID === 3) {
			USDC_instance = new provider.eth.Contract(USDCjson.abi, USDCjson.address);
		}

		if (receivers[0].receiver !== '' && receivers[0].amount !== '' && receivers[0].amount > 0) {
			settxloading(true);

			const receiverArray = [];
			const ammountArray = [];
			var totalAmmount = receiverLength - 1;
			receivers.forEach(function(item, index) {
				if (item.receiver !== '' && item.amount !== '') {
					let formattedAmmount = parseFloat(item.amount).toFixed(2).toString();
					receiverArray.push(item.receiver.replace(/ /g, ''));
					ammountArray.push(provider.utils.toWei(formattedAmmount, 'Mwei'));
					totalAmmount += parseFloat(formattedAmmount);
				}
			});
			totalAmmount = totalAmmount.toFixed(2);
			if (receiverLength === 1) {
				USDC_instance.methods
					.transfer(receiverArray[0], ammountArray[0])
					.send({ from: userAddress })
					.on('transactionHash', function(hash) {
						if (chainID === 1) {
							settransactionURL(`https://etherscan.io/tx/${hash}`);
						} else {
							settransactionURL(`https://ropsten.etherscan.io/tx/${hash}`);
						}
						settxloading(false);
						setisOpen(true);
					})
					.on('error', () => {
						settxloading(false);
					});
				return;
			}
			let totalAmount2 = totalAmmount.toString();

			const deadline = Math.floor(Date.now() / 1000 + 3600 + Math.random() * 3601); //valid for an hour ++
			const Spender_instance = new provider.eth.Contract(Spender.abi, Spender.address);
			if (totalAmount2 !== 'NaN') {
				var InputValue2 = provider.utils.toWei(totalAmount2, 'Mwei');
				var name = await USDC_instance.methods.name().call();
				var nonce = provider.utils.randomHex(32);
				var r, s, v;
				try {
					const data = JSON.stringify({
						domain: {
							name: name, ///
							version: '2', // 2
							chainId: chainID, // 3 chainId
							verifyingContract: USDCjson.address ///
						},
						types: {
							EIP712Domain: [
								{ name: 'name', type: 'string' },
								{ name: 'version', type: 'string' },
								{ name: 'chainId', type: 'uint256' },
								{ name: 'verifyingContract', type: 'address' }
							],
							TransferWithAuthorization: [
								{ name: 'from', type: 'address' },
								{ name: 'to', type: 'address' },
								{ name: 'value', type: 'uint256' },
								{ name: 'validAfter', type: 'uint256' },
								{ name: 'validBefore', type: 'uint256' },
								{ name: 'nonce', type: 'bytes32' }
							]
						},

						primaryType: 'TransferWithAuthorization',
						message: {
							from: userAddress, ///
							to: Spender.address, ///
							value: InputValue2, ///
							validAfter: 0,
							validBefore: deadline, ///
							nonce: nonce ///
						}
					});
					var params = [ userAddress, data ];
					var method = 'eth_signTypedData_v4';

					provider.currentProvider.send(
						{
							method,
							params,
							userAddress
						},
						function(err, result) {
							if (err) {
								settxloading(false);
								return;
							}
							if (result.error) {
								settxloading(false);
								return;
							}
							let signature = JSON.stringify(result.result);
							let signature2 = signature.substr(3); //remove 0x
							r = '0x' + signature2.slice(0, 64);
							s = '0x' + signature2.slice(64, 128);
							v = signature2.slice(128, 130);
							v = parseInt(v, 16); //check if 27 or 28.

							let bytesInput = provider.eth.abi.encodeParameters(
								[
									'address',
									'address',
									'uint256',
									'uint256',
									'uint256',
									'bytes32',
									'uint8',
									'bytes32',
									'bytes32'
								],
								[ userAddress, Spender.address, InputValue2, 0, deadline, nonce, v, r, s ]
							);
							/*

								Some Magic to send the transaction
								*/

							Spender_instance.methods
								.Cast(bytesInput, receiverArray, ammountArray)
								.send({ from: userAddress })
								.on('transactionHash', function(hash) {
									if (chainID === 1) {
										settransactionURL(`https://etherscan.io/tx/${hash}`);
									} else {
										settransactionURL(`https://ropsten.etherscan.io/tx/${hash}`);
									}
									settxloading(false);
									setisOpen(true);
								})
								.on('error', () => {
									settxloading(false);
								});
						}
					);
				} catch (err) {
					settxloading(false);
					return;
				}
			}
		}
		ReactGa.event({
			category: 'Button',
			action: 'Cast transactions'
		});
	};

	const addReceiver = (e) => {
		e.preventDefault();

		if (receivers.length < 35) {
			setreceivers([ ...receivers, { ...blankReceiver } ]);
		}
		if (receivers.length > 4) {
			setTimeout(function() {
				divRref.current.scrollIntoView({
					behavior: 'smooth',
					block: 'end'
				});
			}, 500);
		}

		ReactGa.event({
			category: 'Button',
			action: 'Add rows'
		});
	};
	const deleteReceiver = (e) => {
		e.preventDefault();
		// assigning the list to temp variable
		if (receivers.length > 1) {
			const temp = [ ...receivers ];
			// removing the element using splice
			temp.pop();
			setreceivers(temp);
		} else if (receivers.length === 1) {
			const updatedReceivers = [ ...receivers ]; // idx = index
			updatedReceivers[0].amount = '';
			updatedReceivers[0].receiver = '';
			setreceiversAmmount(0);
			setreceivers(updatedReceivers);
		}
		if (receivers.length <= 5) {
			setTimeout(function() {
				divRref.current.scrollIntoView({
					behavior: 'smooth',
					block: 'center'
				});
			}, 500);
		}
		ReactGa.event({
			category: 'Button',
			action: 'Delete rows'
		});
	};

	const removeReceiver = (e, id) => {
		// assigning the list to temp variable
		e.preventDefault();
		if (receivers.length > 1 && id !== 0) {
			const updatedReceivers = [ ...receivers ]; // idx = index
			updatedReceivers.splice(id, 1);
			setreceivers(updatedReceivers);
		}
	};
	const handleAmmountChange = (e) => {
		e.preventDefault();
		if (!(e.target.value < 0) && !isNaN(e.target.value)) {
			const updatedReceivers = [ ...receivers ]; // idx = index
			updatedReceivers[e.target.dataset.idx].amount = e.target.value;
			setreceivers(updatedReceivers);
		}
	};
	const handleAddressChange = (e) => {
		e.preventDefault();
		const updatedReceivers = [ ...receivers ]; // idx = index
		updatedReceivers[e.target.dataset.idx].receiver = e.target.value;
		setreceivers(updatedReceivers);
	};
	const closeModal = (e) => {
		e.preventDefault();
		settransactionURL('');
		setMessage('');
		setisOpen(false);
		setCheckboxValue2(true);
	};
	const handleCheckbox = (e) => {
		setCheckboxValue(!checkboxValue);
		validateForm();
	};

	return (
		<React.Fragment>
			{pageloading === true ? (
				<LoaderScreen />
			) : (
				<div ref={divRref}>
					{/* txloading && <TxLoader /> */}
					<PopUpModal
						closeModal={closeModal}
						downloadfunction={downloadfunction}
						transactionURL={transactionURL}
						isOpen={isOpen}
						Message={Message}
						checkboxValue2={checkboxValue2}
						setCheckboxValue2={setCheckboxValue2}
					/>
					<Header
						userAddress={userAddress}
						ensName={ensName}
						userBalance={userBalance}
						usdcBalance={usdcBalance}
						provider={provider}
						loadWeb3Modal={loadWeb3Modal}
					/>
					<div
						style={{
							alignItems: 'center',
							backgroundColor: '#282c34',
							color: 'white',
							display: 'flex',
							flexDirection: 'column',
							fontSize: 'calc(10px + 2vmin)',
							minHeight: 'calc(100vh - 70px)'
						}}
					>
						{!userAddress && <IntroPage />}
						{userAddress && (
							<Box style={{ width: '850px' }} ref={divRref}>
								<Form autocomplete="off" style={{ marginBottom: '30px' }}>
									<TableTitle />
									{receivers.map((val, idx) => {
										const receiverId = `Receiver-${idx}`;
										const amountId = `Amount-${idx}`;
										return (
											<div key={`receiver-${idx}`}>
												<Flex>
													<Box
														style={{ borderStyle: 'ridge' }}
														p={3}
														width={75 / 100}
														bg="blue"
													>
														<Input
															style={{
																width: '100%'
															}}
															name={receiverId}
															key={receiverId}
															id={receiverId}
															type="search"
															data-idx={idx}
															className="receiver"
															required
															placeholder="e.g. Spellcaster.eth or 0xAc03B...9e108"
															value={receivers[idx].receiver}
															onChange={handleAddressChange}
															autocomplete="off"
														/>
													</Box>
													<Box
														style={{ borderStyle: 'ridge' }}
														p={3}
														width={25 / 100}
														bg="blue"
													>
														<Input
															style={{
																width: '100%'
															}}
															pattern="^\d*(\.\d{0,2})?$"
															step="0.01"
															name={amountId}
															type="number"
															data-idx={idx}
															required
															key={amountId}
															id={amountId}
															className="ammount"
															value={receivers[idx].amount}
															placeholder="e.g. 12.30"
															onChange={handleAmmountChange}
														/>
													</Box>{' '}
													<Button.Text
														contrastColor="#E8E8E8"
														size="medium"
														onClick={(e) => {
															removeReceiver(e, idx);
														}}
														style={{
															margin: 'auto',
															textDecoration: 'none',
															cursor: 'default'
														}}
													>
														{' '}
														{idx !== 0 && <pre>❌</pre>}
													</Button.Text>
												</Flex>
											</div>
										);
									})}
									<div style={{ marginTop: '15px', display: 'flex', justifyContent: 'start' }}>
										{' '}
										<Button
											style={{
												marginRight: '15px'
											}}
											icon="AddCircleOutline"
											onClick={addReceiver}
										>
											Add
										</Button>
										<Button
											style={{
												marginRight: '15px'
											}}
											icon="RemoveCircleOutline"
											variant="danger"
											onClick={deleteReceiver}
										>
											Delete
										</Button>
										<Button mainColor="grey" onClick={resolvefunction}>
											Resolve ENS
										</Button>
										<Field style={{ margin: 'auto' }} label="I will cast it at my own risk.">
											<Form.Check
												style={{ marginTop: '-4px' }}
												value={checkboxValue}
												onChange={handleCheckbox}
												required // set required attribute to use brower's HTML5 input validation
											/>
										</Field>
									</div>
									<Button
										contrastColor="yellow"
										variant="primary-dark"
										style={{
											float: 'right',
											marginBottom: '40px',
											marginTop: '18px',
											marginRight: '50px'
										}}
										icon="Send"
										disabled={!validated}
										onClick={cfunction}
									>
										{!txloading && <p>Send</p>}
										{txloading && <Loader color="yellow" />}
									</Button>
									<p>
										Total Cost : {receiversAmmount} USDC ( Fees : {receivers.length - 1} )
									</p>
								</Form>
							</Box>
						)}
						{userAddress && (
							<div style={{ fontSize: 'x-large' }}>
								{receivers.length < 5 && <LeftDemoAddress chainID={chainID} />}
								{receivers.length < 5 && (
									<RightInfoBox
										ffunction={ffunction}
										faucetLoading={faucetLoading}
										ethtoUsdc={ethtoUsdc}
										chainID={chainID}
										gasPrice={gasPrice}
										blockNumber={blockNumber}
									/>
								)}
							</div>
						)}
					</div>
				</div>
			)}
			<CookieConsent
				location="bottom"
				buttonText="I understand"
				cookieName="Google Analytics"
				style={{ background: '#2B373B' }}
				buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
			>
				This website uses cookies to improve user experience.{' '}
			</CookieConsent>
		</React.Fragment>
	);
}

export default App;
